import { combineReducers } from "redux";
import Settings from "./Setting";
import Common from "./Common";
import UserData from "./UserData";
import Token from "./Token";
import { connectRouter } from "connected-react-router";

const createBrowserHistory = require("history").createBrowserHistory;
const history = createBrowserHistory();
const rootReducer = combineReducers({
  settings: Settings,
  common: Common,
  userData: UserData,
  token: Token,
  router: connectRouter(history),
});

export default rootReducer;
